import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { EMPTY, interval } from 'rxjs';
import { catchError, debounceTime, filter, switchMap, take } from 'rxjs/operators';

import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { WACloudApiSettings } from 'src/app/core/alcmeon-context/models';
import { facebookSDKInitializer } from 'src/app/parameters/add-account/whatsapp-cloud-api/shared/facebook-sdk-initializer';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { StepAccountTypeComponent } from './whatsapp-cloud-api-pre-qualify/step-account-type/step-account-type.component';
import { StepConnectAccountComponent } from './whatsapp-cloud-api-pre-qualify/step-connect-account/step-connect-account.component';
import { StepPaymentLineComponent } from './whatsapp-cloud-api-pre-qualify/step-payment-line/step-payment-line.component';
import { StepPhoneNumberComponent } from './whatsapp-cloud-api-pre-qualify/step-phone-number/step-phone-number.component';
import { WhatsappCloudApiPreQualifyComponent } from './whatsapp-cloud-api-pre-qualify/whatsapp-cloud-api-pre-qualify.component';
import { WhatsappTemplatesModule } from '../../message-templates/whatsapp-templates/whatsapp-templates.module';

function initLoginFacebookSDKInitializer(alcmeonContextService: AlcmeonContextService, httpClient: HttpClient) {
  return async () => await _loginFacebookSDKInitializer(httpClient, alcmeonContextService);
}

/**
 * Allows to login to Meta Business Service to be able to connect accounts through WhatsApp Cloud API.
 *
 * @param httpClient
 * @param alcmeonContextService
 */
async function _loginFacebookSDKInitializer(httpClient: HttpClient, alcmeonContextService: AlcmeonContextService) {
  // Trick to wait the companyId is loaded and the jwt is valid.
  interval(1000)
    .pipe(
      debounceTime(500),
      filter(
        () =>
          alcmeonContextService.companyId &&
          alcmeonContextService.hasJwt() &&
          !!alcmeonContextService.self &&
          !!alcmeonContextService.isLoggedUserAdmin()
      ),
      take(1),
      switchMap(() =>
        httpClient
          .get<WACloudApiSettings>(
            `${API_URL_COMPANIES}/${alcmeonContextService.companyId}/whatsapp-cloud-api/settings`
          )
          .pipe(catchError(() => EMPTY))
      )
    )
    .subscribe({
      next: settings => {
        if (settings) {
          alcmeonContextService.waCloudApiSettings = settings;
          facebookSDKInitializer(settings);
        }
      },
    });
  return Promise.resolve(true);
}

@NgModule({
  declarations: [
    WhatsappCloudApiPreQualifyComponent,
    StepAccountTypeComponent,
    StepPhoneNumberComponent,
    StepConnectAccountComponent,
    StepPaymentLineComponent,
  ],
  imports: [SharedModule, CommonModule, WhatsappTemplatesModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initLoginFacebookSDKInitializer,
      multi: true,
      deps: [AlcmeonContextService, HttpClient],
    },
  ],
})
export class WhatsappCloudApiModule {}
